module.exports = __webpack_public_path__ + "static/media/footerimage.75f50006.jpg";